import type { FC, ClipboardEvent } from 'react';
import { useRef } from 'react';

import { StyledTextField } from './VerificationStyledComponents';

export interface IVerificationCodeInputProps {
  index: number;
  inputRef: (instance: HTMLInputElement, index: number) => void;
  handleInput: (index: number) => void;
  handleDelete: (index: number) => void;
  handlePaste: (event: ClipboardEvent<HTMLDivElement>) => void;
  isError: boolean;
  isSubmitting: boolean;
}

export const VerificationCodeInput: FC<IVerificationCodeInputProps> = (props) => {
  const { index, inputRef, handleInput, handleDelete, handlePaste, isError, isSubmitting } = props;

  const verificationInputRef = useRef<HTMLInputElement | null>(null);

  const onSetInputRef = (instance: HTMLInputElement) => {
    verificationInputRef.current = instance;
    inputRef(instance, index);
  };

  const handleVerificationInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    // eslint-disable-next-line no-param-reassign -- needs to reassign e.target
    e.target.value = e.target.value.replaceAll(/\D/g, '');
    if (e.target.value) {
      handleInput(index);
    }
  };

  const handleFocus = () => {
    if (verificationInputRef.current) {
      verificationInputRef.current.select();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (!verificationInputRef.current) {
      return;
    }

    if (event.key === 'Backspace' || event.key === 'Delete') {
      if (verificationInputRef.current.value) {
        verificationInputRef.current.value = '';
      } else {
        event.preventDefault();

        handleDelete(index);
      }
    }
  };

  return (
    <StyledTextField
      type="text"
      variant="outlined"
      inputProps={{ maxLength: 1, autoComplete: 'off', inputMode: 'numeric' }}
      inputRef={onSetInputRef}
      error={isError}
      disabled={isSubmitting}
      onInput={handleVerificationInput}
      onKeyDown={handleKeyDown}
      onFocus={handleFocus}
      onPaste={handlePaste}
    />
  );
};
